
import { Component, EventEmitter, Inject, Input, OnInit, Optional, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { OrganizationUtilService } from '../../../../../core/services/organization-util.service';
import { GlobalSettingsService } from '../../../../../core/services/global-settings.service';
import _ from 'lodash';
import { Organization } from '../../../../../core/models/model';
import { IncidentCategory } from '../../../../../core/models/incident-category.model';
import { Permission } from '../../../../../core/interfaces/pin-activation.types';
import { PinActivationService } from '../../../../../core/services/pin-activation.service';
import { DataService } from '../../../../../core/services/data.service';
import { ResponseModalComponent } from '../../../response-modal/response-modal.component';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IncidentCategoryService } from '../../../../../core/services/incident-category.service';
import { SafeZoneMapEntity } from '../../../../../core/services/safe-zone-map-entity.service';
import { CameraService } from '../../../../../core/services/camera.service';

@Component({
  selector: 'app-creator-dialog',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './creator-dialog.component.html',
  styleUrl: './creator-dialog.component.css',
})
export class CreatorDialogComponent implements OnInit {
  @Input() data: any;
  @Input() dialogRef: any;
  @Output() close = new EventEmitter<any>();
  @Output() cancel = new EventEmitter<void>();
  @Input() dialogData: any;
  organizations: Organization[] = [];
  selectedOrganization: Organization | null = null;
  orgIncidentCategoryList: IncidentCategory[] = [];
  selectedIncidentCategory: IncidentCategory | null = null;
  
  incidentTypeList: any[] = [
    { label: 'Public', type: 'public' },
    { label: 'Private', type: 'private' }
  ];
  selectedIncidentType: any = this.incidentTypeList[1];
  name: string = '';
  description: string = '';
  selectedUser: any = null;
  userSearch: any[] = [];
  entitytype: string = 'Incident';
  mapEntity: any = {};
  isIncident = true;
  headerMsg = '';
  permissions?: Permission;
  IncidentMapEntity: any;
  SafeZoneMapEntity: any;
  orgIncidentCategoryDict: Record<string, IncidentCategory[]> = {};
  error = false;
  errorMessage = '';

  constructor(
    private orgUtil: OrganizationUtilService,
    private globalSettings: GlobalSettingsService,
    private pinService: PinActivationService,
    private dataService: DataService,
    private modalService: NgbModal,
    private incidentCategoryService: IncidentCategoryService,
    @Optional() public activeModal: NgbActiveModal,
    public cameraService: CameraService,
  ) {}

  ngOnInit(): void {
    if (this.dialogData) {
      this.data = this.dialogData.data;
      this.entitytype = this.dialogData.entitytype;
      this.IncidentMapEntity = this.dialogData.IncidentMapEntity;
      this.SafeZoneMapEntity = this.dialogData.SafeZoneMapEntity;
    }
      // highGeometry: { coordinates: [cartographicPositions] },
    // Initialize mapEntity and data
    this.mapEntity = {
      name: this.data?.name || '',
      description: this.data?.description || '',
      focalPoint: this.data?.focalPointGeo || undefined
    };
    this.name = this.mapEntity.name;
    this.description = this.mapEntity.description;
    this.isIncident = typeof this.IncidentMapEntity === 'function' && (this.data instanceof this.IncidentMapEntity);
    this.entitytype = this.isIncident
      ? (this.data.getIsMuster?.() ? 'Geofence' : 'Incident')
      : (this.data instanceof SafeZoneMapEntity ? 'Safe Zone' : 'Incident');

    if (this.isIncident || !this.isIncident && this.entitytype != 'Safe Zone') {
      this.loadOrgIncidentCategoryInfo();
      this.getActionSessionForCreatePerimeter();
      this.loadOrgData();
    }
  }

  getActionSessionForCreatePerimeter() {
    this.dataService.getActionSessionForCreatePerimeter().subscribe({
      next: (permissions: any) => {
        Object.values(permissions).forEach((perm: any) => {
          if (perm?.rows && perm.rows.length > 0) {
            let topOrgs = perm.rows[0].organizationIds;
            topOrgs.forEach((topOrg: string) => {
              const org = this.orgUtil.myOrgs[topOrg];
              if (org && org.descendants && org.descendants.length > 0) {
                perm.rows[0].organizationIds.push(...org.descendants);
              }
            });
          }
        });
        this.permissions = permissions;
        this.loadOrgData();
      },
      error: (error: any) => {
        console.error('Failed to load permissions', error);
      }
    });
  }
  loadOrgIncidentCategoryInfo() {
    const orgId = this.dialogData?.organizationId;
    this.orgUtil.getIncidentCategoryInfo(orgId).subscribe({
      next: (result) => {
        this.orgIncidentCategoryDict = result;
        this.getAllOrgsForIncident();
      },
      error: (err) => {
        console.error('Failed to load incident categories', err);
      },
    });
  }

  getAllOrgsForIncident() {
    const perimeterId = this.globalSettings.getPerimeterIdForIncidentCreation();
    if (perimeterId) {
      this.orgUtil.getOrgsAvailForIncident(perimeterId).subscribe({
        next: (orgIds: string[]) => {
          const originalOrgIdForIncidentCreation =
            this.globalSettings.getOriginalOrgIdForIncidentCreation();
          if (orgIds.length === 0) {
            orgIds = [originalOrgIdForIncidentCreation];
          }
          const topOrgId = _.orderBy(orgIds, (o) => parseInt(o))[0];
          let orgs = orgIds.map((orgId) => this.orgUtil.myOrgs[orgId]);
          orgs = orgs.filter((org) => !!org);
          orgs = _.orderBy(orgs, ['name'], ['asc']);
          orgs = orgs.filter((o) => o.id !== topOrgId);
          orgs = _.concat([this.orgUtil.myOrgs[topOrgId]], orgs);
          this.organizations = orgs;
          if (this.organizations.length > 0 && !this.selectedOrganization) {
            this.selectedOrganization = this.organizations[0];
          }
          if (this.dialogData?.orgIncidentCategoryId) {
            const allCategories = Object.values(
              this.orgIncidentCategoryDict
            ).flat();
            const orgOfOic = allCategories.find(
              (cat) => cat.id === this.dialogData.orgIncidentCategoryId
            );
            if (orgOfOic) {
              this.selectedOrganization = this.organizations.find(org => org.id === orgOfOic.id) || null;
            }
          } else {
            this.selectedOrganization =
              this.organizations.find(
                (org) => org.id === originalOrgIdForIncidentCreation
              ) || this.organizations[0];
          }
          this.onSelectedOrgChanged();
          this.headerMsg =
            this.organizations.length >= 2
              ? 'To Activate incident, select organization and enter PIN. Once incident is active, users inside the geofence will be notified of this event.'
              : 'To Activate incident, enter PIN. Once incident is active, users inside the geofence will be notified of this event.';
        },
        error: (error) => {
        },
      });
    } else {
      const incidentId = this.dialogData?.incidentId;
      if (incidentId) {      }
    }
  }

  loadOrgData(): void {
    let orgs = Object.values(this.orgUtil.myOrgs || {});
    orgs = _.sortBy(orgs, 'name');
    orgs = orgs.filter(
      (org: any) => org.name !== 'Root' && org.name !== 'Customer Root'
    );
    this.organizations = orgs as Organization[];
    let perms: any[] = [];
    if (this.permissions?.privateGeofence?.rows) {
      perms = perms.concat(this.permissions.privateGeofence.rows);
    }
    if (this.permissions?.publicGeofence?.rows) {
      perms = perms.concat(this.permissions.publicGeofence.rows);
    }
    let orgIds: string[] = [];
    perms.forEach((p: any) => {
      if (Array.isArray(p.organizationIds)) {
        orgIds.push(...p.organizationIds);
      }
    });
    this.organizations = this.organizations
      .filter((o: any) => orgIds.includes(o.id) && o.name)
      .sort((a, b) => this.buildAncestorLabel(a).localeCompare(this.buildAncestorLabel(b)));
    if (this.organizations.length > 0) {
      this.selectedOrganization = this.organizations[0];
      this.onSelectedOrgChanged();
    }
  }

  userChanged(value: any) {
    this.selectedUser = value || undefined;
  }

  onSelectedOrgChanged() {
    const selOrgId: string | undefined = this.selectedOrganization?.id;
    const oics = (selOrgId && this.orgIncidentCategoryDict && this.orgIncidentCategoryDict.hasOwnProperty(selOrgId))
      ? this.orgIncidentCategoryDict[selOrgId]
      : [];
    const oicsWithCustom = [
      ...oics,
      { id: null, label: 'Custom', description: 'Custom', public: false, iconCode: '' }
    ];
    this.orgIncidentCategoryList = oicsWithCustom;
    this.selectedIncidentCategory = this.orgIncidentCategoryList[0];
    if (this.data.orgIncidentCategoryId) {
      let initialWasInList = this.orgIncidentCategoryList.find((cat: any) => cat.id === this.data.orgIncidentCategoryId);
      if (initialWasInList) {
        this.selectedIncidentCategory = initialWasInList;
      }
    }
    this.resetTypeMenu();
    this.incidentCategorySelected();
  }

  incidentCategorySelected() {
    if (!this.selectedIncidentCategory) return;
    this.name = this.selectedIncidentCategory.label;
    this.description = this.selectedIncidentCategory.description;
    if (this.incidentTypeList.length === 1) {
      this.selectedIncidentType = this.incidentTypeList[0];
    } else if (this.selectedIncidentCategory.public) {
      this.selectedIncidentType = this.incidentTypeList[0];
    } else {
      this.selectedIncidentType = this.incidentTypeList[1];
    }
  }
  buildAncestorLabel(org: Organization): string {
    if (!org || !org.name) return '';
    if (
      !org.orgData.parentId ||
      org.orgData.parentId === '1' ||
      org.orgData.parentId === '7'
    ) {
      return org.name;
    }
    const parent = this.orgUtil.myOrgs[org.orgData.parentId];
    if (!parent || !parent.name) {
      return org.name;
    }
    return this.buildAncestorLabel(parent) + ' -> ' + org.name;
  }
  private resetTypeMenu() {
    if (!this.permissions || !this.selectedOrganization) return;
    const privateAllowed = this.hasPrivatePermission();
    const publicAllowed = this.hasPublicPermission();
    this.incidentTypeList = [];
    if (publicAllowed) {
      this.incidentTypeList.push({ label: 'Public', type: 'public' });
    }
    if (privateAllowed) {
      this.incidentTypeList.push({ label: 'Private', type: 'private' });
    }
  }

  private hasPrivatePermission(): boolean {
    if (!this.permissions || !this.selectedOrganization) return false;
    return true;
  }

  private hasPublicPermission(): boolean {
    if (!this.permissions || !this.selectedOrganization) return false;
    return true;
  }

  async confirmPublicIncident() {
    if (this.data && typeof this.IncidentMapEntity === 'function' && this.data instanceof this.IncidentMapEntity) {
      let permission = false;
      if (this.selectedIncidentType.type === 'public') {
        permission = !!(this.permissions && this.permissions.privateGeofence && Array.isArray(this.permissions.privateGeofence.rows) && this.permissions.privateGeofence.rows.length > 0);
      }
      if (this.selectedIncidentType.type === 'private') {
        permission = !!(this.permissions && this.permissions.privatePerimeter && Array.isArray(this.permissions.privatePerimeter.rows) && this.permissions.privatePerimeter.rows.length > 0);
      }
      if (!permission) {
        this.setError('Not permitted to create ' + this.selectedIncidentType.type + ' incident');
        return;
      }
      if (this.selectedIncidentType.type === 'public') {
        const confirmed = await this.showConfirm('You are creating a public incident. Are you sure?');
        if (!confirmed) {
          return;
        }
        this.ok();
      } else {
        this.ok();
      }
    } else {
      this.ok();
    }
  }

  ok(): void {
    this.data.name = this.mapEntity.name = this?.name;
    this.data.setDescription?.(this.description);
    this.mapEntity.description = this.description;
    if (!this.name.replace(' ', '')) {
      this.setError('Please enter a name.');
      return;
    }
    if (!this.description.replace(' ', '')) {
      this.setError('Please enter a description.');
      return;
    }
    if (this.data instanceof SafeZoneMapEntity) {
      // TODO: Implement SafeZoneMapEntity logic
      // return ArcAngelService.methods.createSafeZone(this.data.getEventId(), this.data.getName(), this.data.getDescription(), this.data.getLatitude(), this.data.getLongitude()).then(() => {
      //   this.showAlert('New safe zone created succesfully.');
      //   return;
      // }).catch((error: { data: { error: { errors: any; }; }; }) => {
      //   if(error && error.data && error.data.error && _.filter(error.data.error.errors, (err) => {
      //     return err.message === 'label must be unique';
      //   }).length > 0){
      //     this.showAlert('Error: a safezone of the same name (' + this.data.name + ') already exists.');
      //   }else{
      //     this.showAlert('Unable to add safezone to event: ' + this.data.getEventId());
      //   }
      // }).finally(() => {
      //   // $uibModalInstance.close();
      // });

      if (typeof this.data?.setName === 'function') {
        this.data.setName(this.name);
      }
      if (typeof this.data?.setDescription === 'function') {
        this.data.setDescription(this.description);
      }

      const resolvedPerimeterSafezoneId =
        this.data?.perimeterSafezoneId ||
        this.data?.safezone?.perimeterSafezoneId ||
        (typeof this.data?.getPerimeterSafezoneId === 'function' ? this.data.getPerimeterSafezoneId() : undefined) ||
        this.dialogData?.perimeterSafezoneId ||
        this.dialogData?.safezone?.perimeterSafezoneId ||
        (this.data?.safezone?.perimterId || this.data?.safezone?.perimeterId ? (this.data?.safezone?.id || this.data?.id) : undefined) ||
        (this.data?.isPerimeterSafezone?.() ? (this.data?.id || this.data?.safezone?.id) : undefined) ||
        undefined;

      const payload: any = {
        label: this.name || (typeof this.data?.getName === 'function' ? this.data.getName() : this.data?.name),
        description: this.description || (typeof this.data?.getDescription === 'function' ? this.data.getDescription() : this.data?.description),
        active: false,
        geometry: {
          type: 'Point' as 'Point',
          coordinates: [this.data.longitude, this.data.latitude]
        },
        perimeterSafezoneId: resolvedPerimeterSafezoneId,
        incidentId: this.data.eventId || this.cameraService?.getCurrentIncidentId?.() || undefined,
      };

      const resolvedOrgId =
        this.data?.organizationId ||
        this.data?.safezone?.organizationId ||
        this.selectedOrganization?.id;
      if (resolvedOrgId) {
        payload.organizationId = String(resolvedOrgId);
      }

      this.incidentCategoryService.createSafeZoneFromPayload(payload).subscribe({
        next: () => {
          // Close the asking modal immediately on success
          this.closeDialog({ success: true });
          // Optionally show success info after closing
          this.showAlert('New safe zone created successfully.');
        },
        error: (err: any) => {
          try {
            const backend = err?.error || err?.data || err;
            const errorsArr = backend?.error?.errors || backend?.errors || [];
            const messages = Array.isArray(errorsArr)
              ? errorsArr.map((e: any) => (e?.message || e || '') + '').join(', ')
              : (backend?.message || '');

            const dupMsg = 'label must be unique';
            const raw = (typeof backend === 'string' ? backend : JSON.stringify(backend || {})).toLowerCase();
            const isDuplicate = raw.includes(dupMsg) || (messages || '').toLowerCase().includes(dupMsg) || err?.status === 409;

            if (isDuplicate) {
              this.showAlert('Error: a safezone of the same name (' + this.data.name + ') already exists.');
              return;
            }

            const incidentId = this.cameraService.getCurrentIncidentId?.() || this.data.getEventId?.() || this.data?.eventId || 'unknown';
            const extra = messages ? ' (' + messages + ')' : '';
            this.showAlert('Unable to add safezone to event: ' + incidentId + extra);
          } catch (_) {
            const incidentId = this.cameraService.getCurrentIncidentId?.() || this.data.getEventId?.() || this.data?.eventId || 'unknown';
            this.showAlert('Unable to add safezone to event: ' + incidentId);
          }
        },
        complete: () => {
          // $uibModalInstance.close();
        }
      });
      return;
    } else if (this.data instanceof this.IncidentMapEntity) {
      if (this.data.name.length < 1) {
        this.showAlert(this.data.entitytype + ' must have a name');
        return;
      } else if (this.description.length < 1) {
        this.showAlert(this.data + ' must have a description');
        return;
      } else if ( this.selectedOrganization?.id === undefined) {
        this.showAlert(this.data.entitytype + ' must have an organization');
        return;
      } else if (!this.selectedIncidentCategory) {
        this.showAlert(this.data + ' must have an incident category');
        return;
      } else if (!this.selectedIncidentType) {
        this.showAlert(this.data + ' must have an incident type');
        return;
      } else if (typeof this.data.getIsMuster === 'function' && this.data.getIsMuster()) {
        if (this.data.selectedUser === undefined) {
          this.showAlert(this.data + ' must have a device');
          return;
        }
        let typeLabel = ' [private]';
        if (this.selectedIncidentType.type === 'public') {
          typeLabel = ' [public]';
        }
        let incidentOptions = {
          coordinates: this.data.obj.highGeometries[0].coordinates[0].map((pt: any) => [pt.lon, pt.lat]),
          name: this.data.name + typeLabel,
          description: this.description,
          orgId: this.selectedOrganization?.id,
          focalPoint: this.mapEntity.focalPoint,
          orgIncidentCategoryId: this.data.incidentCategoryId,
          public: this.data.public
        };
        this.incidentCategoryService.createIncident(incidentOptions).subscribe({
          next: (result) => {
            // return ArcAngelService.methods.createGeofence(this.data.getCoordinates(),this.data.mapEntity.name, this.data.mapEntity.description, this.data.selectedOrganization.getId(), this.selectedUser.id, result);
            this.showAlert('New geofence created succesfully');
            return;
          },
          error: () => {
            this.closeDialog();
            this.showAlert('Failed to create new geofence.');
          }
        });
        return;
      }

      this.data.incidentCategoryId = this.selectedIncidentCategory.id;
      this.data.public = this.selectedIncidentType.type === 'public';

      let typeLabel = ' [private]';
      if (this.selectedIncidentType.type === 'public') {
        typeLabel = ' [public]';
      }

      let incidentOptions = {
        coordinates: this.data.obj.highGeometries[0].coordinates[0].map((pt: any) => [pt.lon, pt.lat]),
        name: this.data.name + typeLabel,
        description: this.description,
        orgId: this.selectedOrganization?.id,
        focalPoint: this.mapEntity.focalPoint,
        
        orgIncidentCategoryId: this.data.incidentCategoryId,
        public: this.data.public
      };

      this.incidentCategoryService.createIncident(incidentOptions).subscribe({
        next: (id: any) => {
          this.closeDialog();
          this.showAlert('New incident created succesfully');
          return;
        },
        error: () => {
          this.closeDialog();
          this.showAlert('Failed to create new Incident');
        }
      });
      return;
    }
    this.closeDialog();
  }

  setError(msg: string) {
    this.error = true;
    this.errorMessage = msg;
  }

  cancelDialog() {
    this.close.emit('cancel');
    this.dialogRef?.close?.('cancel');
    // Close with a 'cancel' result so parent can resume overlay
    this.activeModal?.close('cancel');
  }
  
  closeDialog(result?: any) {
    this.close.emit(result);
    this.dialogRef?.close?.(result);
    this.activeModal?.close(result);
  }

  private showAlert(message: string) {
      const modalRef = this.modalService.open(ResponseModalComponent, {
        centered: true,
        windowClass: 'response-modal-top zindex',
        backdropClass: 'response-modal-backdrop-top'
      });
      modalRef.componentInstance.message = message;
      modalRef.componentInstance.showCancel = false;
      return modalRef.result;
    }
  
    private showConfirm(message: string): Promise<boolean> {
      const modalRef = this.modalService.open(ResponseModalComponent, {
        centered: true,
        windowClass: 'response-modal-top zindex',
        backdropClass: 'response-modal-backdrop-top'
      });
      modalRef.componentInstance.message = message;
      modalRef.componentInstance.showCancel = true;
      return modalRef.result;
    }
}